import { type FC } from "react";

import { Button, Group, Text } from "@mantine/core";

import {
    Cancel,
    CheckedCopyingAllowed,
    CheckedCopyingAllowedShort,
    ConfirmChanges,
    ConfirmChangesShort,
    ConfirmDelete,
    Delete,
    EditCopying,
} from "./messages.generated";

export type RemoteAssetsMode = "normal" | "delete" | "editCopying";

interface RemoteAssetsToolbarProps {
    mode: RemoteAssetsMode;
    actionCount: number;
    onEnterDeleteMode: () => void;
    onEnterEditCopyingMode: () => void;
    onCancel: () => void;
    onConfirmDelete: () => void;
    onConfirmCopyingChanges: () => void;
    isConfirming: boolean;
    isMobile?: boolean;
}

export const RemoteAssetsToolbar: FC<RemoteAssetsToolbarProps> = ({
    mode,
    actionCount,
    onEnterDeleteMode,
    onEnterEditCopyingMode,
    onCancel,
    onConfirmDelete,
    onConfirmCopyingChanges,
    isConfirming,
    isMobile,
}) => {
    if (mode === "delete") {
        return (
            <Group gap="xs" wrap="nowrap">
                <Button variant="subtle" onClick={onCancel} disabled={isConfirming}>
                    <Cancel />
                </Button>
                <Button onClick={onConfirmDelete} disabled={actionCount === 0} loading={isConfirming}>
                    <ConfirmDelete checkedCount={actionCount} />
                </Button>
            </Group>
        );
    }

    if (mode === "editCopying") {
        return (
            <Group gap="xs" wrap="nowrap">
                <Text size="sm" c="dimmed" style={{ whiteSpace: "nowrap" }}>
                    {isMobile ? <CheckedCopyingAllowedShort /> : <CheckedCopyingAllowed />}
                </Text>
                <Button variant="subtle" onClick={onCancel} disabled={isConfirming}>
                    <Cancel />
                </Button>
                <Button onClick={onConfirmCopyingChanges} disabled={actionCount === 0} loading={isConfirming}>
                    {isMobile ? (
                        <ConfirmChangesShort changedCount={actionCount} />
                    ) : (
                        <ConfirmChanges changedCount={actionCount} />
                    )}
                </Button>
            </Group>
        );
    }

    return (
        <Group gap="xs" wrap="nowrap">
            <Button variant="default" onClick={onEnterEditCopyingMode}>
                <EditCopying />
            </Button>
            <Button variant="default" onClick={onEnterDeleteMode}>
                <Delete />
            </Button>
        </Group>
    );
};
